import { lazyWithRetry } from "utils/lazy-with-retry";
import { ICreateEditGaiaObjectProps } from "./definitions";

const LazyCreateEditGaiaObject = lazyWithRetry(
  () => import("./CreateEditGaiaObject"),
);

const CreateEditGaiaObject = (props: ICreateEditGaiaObjectProps) => (
  <LazyCreateEditGaiaObject {...props} />
);

export default CreateEditGaiaObject;
